import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { getSchemaAttrs, nodeToDOM, toAttributeBoolean, toAttributeBooleanString } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

const HTML5VideoAttrName = 'MadCap:HTML5Video';
const MadCapMultimediaParamControlsAttrName = 'MadCap:Param_controls';
const MadCapMultimediaParamMutedAttrName = 'MadCap:Param_muted';
const MadCapMultimediaParamLoopAttrName = 'MadCap:Param_loop';
const MadCapMultimediaParamAutoplayAttrName = 'MadCap:Param_autoplay';

export class MadCapMultimediaSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapmultimedia: {
      group: 'inline',
      inline: true,
      content: 'inline*',
      definingForContent: true,
      atom: true,
      attrs: {
        src: { default: undefined },
        [HTML5VideoAttrName]: {
          default: undefined,
          toFlareXML(value: any): string {
            return toAttributeBooleanString(value);
          }
        },
        [MadCapMultimediaParamControlsAttrName]: {
          default: undefined
        },
        [MadCapMultimediaParamMutedAttrName]: {
          default: undefined,
          toFlareXML(value: any): string {
            return toAttributeBooleanString(value);
          }
        },
        [MadCapMultimediaParamLoopAttrName]: {
          default: undefined,
          toFlareXML(value: any): string {
            return toAttributeBooleanString(value);
          }
        },
        [MadCapMultimediaParamAutoplayAttrName]: {
          default: undefined,
          toFlareXML(value: any): string {
            return toAttributeBooleanString(value);
          }
        }
      },
      parseDOM: [{
        tag: 'object',
        getAttrs(dom: HTMLElement) {
          const attrs = getSchemaAttrs(dom, ['src', HTML5VideoAttrName, MadCapMultimediaParamControlsAttrName, MadCapMultimediaParamMutedAttrName, MadCapMultimediaParamLoopAttrName, MadCapMultimediaParamAutoplayAttrName]);
          return {
            ...attrs,
            [HTML5VideoAttrName]: toAttributeBoolean(attrs[HTML5VideoAttrName]),
            [MadCapMultimediaParamMutedAttrName]: toAttributeBoolean(attrs[MadCapMultimediaParamMutedAttrName]),
            [MadCapMultimediaParamLoopAttrName]: toAttributeBoolean(attrs[MadCapMultimediaParamLoopAttrName]),
            [MadCapMultimediaParamAutoplayAttrName]: toAttributeBoolean(attrs[MadCapMultimediaParamAutoplayAttrName])
          };
        },
        preserveWhitespace: true
      }],
      toDOM(node) { return nodeToDOM(node); },
      isTagNameBox: true,
      tagName: 'object'
    },

    param: {
      group: 'inline',
      content: 'inline*', // param was originally created with inline* content even though its void. It needs to stay this way for compatibility with existing docs.
      definingForContent: true, // param was originally created with definingForContent. It needs to stay this way for compatibility with existing docs.
      inline: true,
      isVoid: true,
      parseDOM: [{
        tag: 'param'
      }],
      toDOM(node) { return nodeToDOM(node); },
      atom: true,
      isTagNameBox: true
    }
  } satisfies Record<string, NodeSpec>;
}
